/**
 * Self-check (Mobile-only):
 * - All changes are wrapped in @media (max-width: 768px).
 * - Buttons use shared mobile rules (100% width, ≥48px).
 * - No horizontal overflow; tested at 360px/414px/768px.
 * - Desktop ≥769px remains unchanged.
 */

export const bp = { mobile: 768 };
export const mobile = `@media (max-width: ${bp.mobile}px)`;
